const statisticCounter = () => {

    let interval = 5000;
    const intersections = new Map();

    const animarCont = (valueDisplay) => {
        let startValue = 0;
        let endValue = parseInt(valueDisplay.getAttribute('data-count'));

        let duration = Math.floor(interval / endValue);

        let counter = setInterval(function () {
            startValue += 1;
            valueDisplay.textContent = startValue;
            if (startValue === endValue) {
                clearInterval(counter);
            }
        }, duration);

        return counter;
    }

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            // console.log(entry)
            // if(entry.isIntersecting) {
            //     animarCont(entry.target);
            // }
            if (entry.isIntersecting && intersections.get(entry.target) != null) {
                // console.log('div is in viewport');
                clearInterval(intersections.get(entry.target));
                intersections.set(entry.target, animarCont(entry.target) );
            } else if (entry.isIntersecting) {
                // console.log('div is in viewport');
                intersections.set(entry.target, animarCont(entry.target) );
            } else if (!entry.isIntersecting && intersections.get(entry.target) != null) {
                // console.log('div is not in viewport');
                clearInterval(intersections.get(entry.target));
            }
        });
    });


    const valueDisplays = document.querySelectorAll('.count');

    // Si existen items
    if (valueDisplays.length > 0) {
        valueDisplays.forEach((el) => observer.observe(el));
    }


    // valueDisplays.forEach( (valueDisplay) => {
    //     let startValue = 0;
    //     let endValue = parseInt(valueDisplay.getAttribute('data-count'));

    //     let duration = Math.floor(interval / endValue);

    //     let counter = setInterval(function(){
    //         startValue += 1;
    //         valueDisplay.textContent = startValue;
    //         if(startValue === endValue){
    //             clearInterval(counter);
    //         }
    //     }, duration);
    // });
}

export default statisticCounter;